import ApplicationInit from './app/init.js'
import { CssAnimation } from './utils/CssAnimation.js';

window.RS = window.RS || {};
window.RS = Object.assign(window.RS, {
	Init: ApplicationInit,
	CssAnimation
});